import { useMemo, useState, useCallback, useEffect } from 'react';
import axios from 'axios';
import { useWorkWithUs } from 'contexts/WorkWithUs.contexts';
import useWelcome from '../../../SelectTypeOfVacancy/useSelectTypeOfVacancy';

const useRegion = () => {
    const { dataFields, errors, updateDataField, updateErrors, updateStatusError } = useWorkWithUs();

    const { translate, transitionIn } = useWelcome();

    // const vtBusLinesDefault = useMemo(() => {
    //     return [
    //         {
    //             label: 'Pega VT',
    //             value: 'Pega VT',
    //         },
    //         {
    //             label: 'Não pega VT',
    //             value: 'Não pega VT',
    //         },
    //         {
    //             label: 'Outros',
    //             value: 'Outros',
    //         },
    //         {
    //             label: 'Veículo Particular',
    //             value: 'Veículo Particular',
    //         },
    //     ];
    // }, []);

    const logradouroList = useMemo(() => {
        return [
            { label: 'Rua', value: 'R' },
            { label: 'Avenida', value: 'AV' },
            { label: 'Alameida', value: 'AL' },
            { label: 'Destrito', value: 'DT' },
            { label: 'Estrada', value: 'EST' },
            { label: 'Lote', value: 'LT' },
            { label: 'Outros', value: 'O' },
        ];
    }, []);

    const regionList = useMemo(() => {
        return [
            { label: 'NORTE', value: 'NORTE' },
            { label: 'LESTE', value: 'LESTE' },
            { label: 'CENTRO', value: 'CENTRO' },
            { label: 'OESTE', value: 'OESTE' },
            { label: 'SUL', value: 'SUL' },
        ];
    }, []);

    // const [selectedStateOption, setSelectedStateOption] = useState(() => {
    //     const work_with_us = JSON.parse(JSON.parse(localStorage.work_with_us));

    //     return work_with_us.regions?.state || null;
    // });

    const [selectedRegionOption, setSelectedRegionOption] = useState(() => {
        const work_with_us = JSON.parse(JSON.parse(localStorage.work_with_us));

        return work_with_us.regions?.options || null;
    });

    //const [vtBusLines, setVTBusLines] = useState(vtBusLinesDefault);

    const [selectedVtBusLines, setSelectedVTBusLines] = useState(() => {
        const work_with_us = JSON.parse(JSON.parse(localStorage.work_with_us));

        return work_with_us.vtBusLines?.options || null;
    });

    const getAddressByCep = useCallback(
        async ({ name, value }, item) => {
            const cepNumber = value.replace('-', '').trim();

            if (name !== 'cep' || cepNumber.length < 8) {
                return;
            }

            const { data } = await axios.get(`https://viacep.com.br/ws/${cepNumber}/json/`);

            if (data === undefined || data.erro === true) {
                return;
            }
            const [logradouroType] = data.logradouro !== undefined ? data.logradouro.split(' ', 2) : '';
            //const addressName = data.logradouro.replace(logradouroType,'').trim();
            const addressName = data?.logradouro ?? '';
            const logradouroItem = logradouroList.filter((logradouro) => logradouro.label === logradouroType);

            updateDataField(item, {
                ...{
                    ...dataFields[item],
                    cep: data.cep,
                    street: addressName,
                    neighborhood: data?.bairro ?? '',
                    city: data?.localidade ?? '',
                    state: data?.uf ?? '',
                    publicPlace: logradouroItem[0]?.value ?? '',
                    region: '',
                },
            });

            updateErrors(item, {
                ...errors[item],
                ...{
                    publicPlace: !logradouroItem[0]?.value,
                    street: !addressName,
                    number: true,
                    neighborhood: !data?.bairro,
                    city: !data?.localidade,
                    state: !data?.uf,
                    region: !data?.region,
                },
            });

            if (data.logradouro) {
                document.getElementById('number').focus();
            }
        },
        [dataFields, errors, logradouroList, updateDataField, updateErrors],
    );

    const handleChangeText = useCallback(
        ({ target }, item) => {
            updateDataField(item, {
                ...{ ...dataFields[item], [target.name]: target.value },
            });

            updateErrors(item, {
                ...{ ...errors[item], [target.name]: false },
            });
            updateStatusError(false);

            getAddressByCep(target, item);
        },
        [dataFields, errors, getAddressByCep, updateDataField, updateErrors, updateStatusError],
    );

    const setWorkWithUsState = useCallback((value) => {
        const work_with_us = JSON.parse(JSON.parse(localStorage.work_with_us));

        work_with_us.regions = {
            type: 'regions',
            options: work_with_us.regions?.options || [],
            state: value ? { label: value.value, value: value.value } : null,
        };

        localStorage.work_with_us = JSON.stringify(JSON.stringify(work_with_us));
    }, []);

    const setWorkWithUsRegion = useCallback((value) => {
        const work_with_us = JSON.parse(JSON.parse(localStorage.work_with_us));

        work_with_us.regions = {
            type: 'regions',
            state: work_with_us.regions.state || null,
            options: value.map((val) => val.value),
        };

        localStorage.work_with_us = JSON.stringify(JSON.stringify(work_with_us));
    }, []);

    // const fillSelectedRegionSaved = useCallback(() => {
    //     const work_with_us = JSON.parse(JSON.parse(localStorage.work_with_us));

    //     const regionOptions = work_with_us?.regions?.options || null;

    //     const regionsOptionsSaved = [];

    //     if (regionOptions && regionOptions.length) {
    //         regionOptions.forEach((region) => {
    //             regionsOptionsSaved.push({
    //                 label: region,
    //                 value: region,
    //             });
    //         });
    //     }
    // }, []);

    // const handleChangeVTBusLines = useCallback(
    //     (value) => {
    //         updateDataField('vtBusLines', {
    //             ...{
    //                 ...dataFields['vtBusLines'],
    //                 options: value,
    //                 type: 'vtBusLines',
    //             },
    //         });

    //         setSelectedVTBusLines(value);
    //     },
    //     [dataFields, updateDataField],
    // );

    // const clearVtLines = useCallback(() => {
    //     const work_with_us = JSON.parse(JSON.parse(localStorage.work_with_us));

    //     work_with_us.vtBusLines = {
    //         type: 'vtBusLines',
    //         options: [],
    //     };

    //     localStorage.work_with_us = JSON.stringify(JSON.stringify(work_with_us));

    //     setVTBusLines(vtBusLinesDefault);

    //     setSelectedVTBusLines(null);
    // }, [vtBusLinesDefault]);

    // useEffect(() => {
    //     fillSelectedRegionSaved();
    // }, [fillSelectedRegionSaved, vtBusLinesDefault]);

    return {
        dataFields,
        errors,
        transitionIn,
        //selectedStateOption,
        selectedRegionOption,
        selectedVtBusLines,
        //vtBusLines,
        logradouroList,
        regionList,
        translate,
        handleChangeText,
        //setSelectedStateOption,
        setSelectedRegionOption,
        setWorkWithUsState,
        setWorkWithUsRegion,
        //clearVtLines,
        //handleChangeVTBusLines,
    };
};

export default useRegion;
